<template>
  <div class="box box-info">
    <form>
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-2">
          <label for="toDate">Store</label>
          <Dropdown
            v-if="!setWarehouseData"
            v-model="warehouseId"
            :options="warehouseLists"
            optionLabel="name"
            id="warehouse"
            :filter="true"
            placeholder="Select store"
            :showClear="true"
          />
          <Dropdown
            v-if="setWarehouseData"
            v-model="warehouseId"
            :options="warehouseLists"
            optionLabel="name"
            id="warehouse"
            :filter="true"
            placeholder="Select store"
            :disabled="true"
          />
        </div>
        <div class="p-field p-col-12 p-md-1 p-mt-5">
          <Button @click.prevent="searchReport"
                  class="p-button-raised" label="Search" icon="pi pi-search"/>
          <!-- <button type="submit" style="margin-left:10px" v-if="this.inventoryInOutStoreLists.length > 0"  @click.prevent="reset"
         class="btn btn-info pull-left">Reset</button> -->
        </div>
        <div class="p-field p-col-12">
          <a href="#" @click.prevent="exportCSV()" v-if="this.inventoryInOutStoreLists.length > 0">
            <img src="../../../../static/img/excel.png" style="float: right;margin-right: 4em;width: 3.5em"/>
          </a>
        </div>
      </div>
    </form>

    <DataTable
      :value="inventoryInOutStoreLists"
      :paginator="true" ref="po"
      :rowsPerPageOptions="[100,500,1000]"
      :rows="100" :filters="filters"
      editMode="cell"
      class="p-datatable-responsive p-datatable-gridlines"
    >
      <Column header="S.N">
        <template #body="sl">
           {{sl.index+1}}
        </template>
      </Column>

      <Column headerStyle="width: 16em" header="Name" field="itemName" :sortable="true" filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['itemName']"/>
        </template>
      </Column>
      <Column header="Code" field="itemCode" :sortable="true" filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['itemCode']"/>
        </template>
      </Column>

      <Column header="Unit" field="unit" :sortable="true" filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['unit']"/>
        </template>
      </Column>
      <Column header="Closing Stock" bodyStyle="text-align: right" :sortable="true" field="closingQuantity"
              filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['closingQuantity']"/>
        </template>
      </Column>
      <Column header="Purchase Rate" bodyStyle="text-align: right" :sortable="true" field="price"
              filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['price']"/>
        </template>
      </Column>
      <Column header="Sales Rate" bodyStyle="text-align: right" :sortable="true" field="sellingRate"
              filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['sellingRate']"/>
        </template>
      </Column>
      <template #empty>No record found</template>
    </DataTable>
    <!-- </div> -->
  </div>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import Dropdown from 'primevue/dropdown'

export default {
  name: 'StoreWiseClosingStock',
  data() {
    return {
      dialogShow: false,
      itemId: '',
      loading: false,
      imageDialog: false,
      filters: {
        global: ''
      },
      inStock: 0,
      warehouseId: '',
      inventoryInOutStoreLists: []
    }
  },
  computed: {
    warehouseLists() {
      return this.$store.state.warehouse.warehouseDropDownList
    }
  },
  mounted() {
    this.columnNames()
    this.warehouseList()
    this.setWarehouse()
  },
  methods: {
    async searchReport() {
      if (this.warehouseId !== '' && this.warehouseId !== null) {
        this.id = this.warehouseId.id
      } else {
        this.id = '0'
      }
      let dat = {
        warehouse: this.id
      }
      this.loading = true
      let resp = await this.$store.dispatch('loadInventoryStockStoreWiseReport', dat)
      this.loading = false
      this.inventoryInOutStoreLists = resp
    },
    setWarehouse() {
      if (this.$store.state.warehouseData.id > 0) {
        this.setWarehouseData = true
        this.warehouseId = this.$store.state.warehouseData
      } else if (this.warehouseLists.length === 1) {
        this.warehouseId = this.warehouseLists[0]
      }
    },
    async warehouseList() {
      await this.$store.dispatch('loadWarehouseDropDown')
    },
    exportCSV() {
      let data = {
        columnList: this.columnList
      }
      axios({
        url: globalKey + '/fileDownload/excelReportAccount/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/Item List' + '/' + this.$store.getters.fyId + '/' + data.columnList,
        method: 'get',
        headers: {'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'itemList.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    columnNames() {
      for (let i = 0; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    }
  },
  components: {
    DataTable,
    Column,
    InputText,
    Button,
    Dropdown
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// storeWiseClosingStock.vue?00f52115